import { useContext, useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import RotateRightIcon from "/src/components/common/icon/RotateRight";
import MagnifyingGlassIcon from "/src/components/common/icon/MagnifyingGlass";
import FilterIcon from "/src/components/common/icon/Filter";

import Dropdown from "./Dropdown";
import Pill from "./Pill";
import Text from "./Text";

import { AppContext } from "/src/components/context/App";

const changeState = (state, id, e) => {
  let newState = { ...state };
  newState[id] = e;
  if (id === "property_type_group") {
    delete newState["property_type"];
  }
  return newState;
}

function fetchParamsToFormValues(fetchParams) {

  const context = useContext(AppContext);
  const formConfig = context?.GET_SEARCH_FIELDS?.() || [];

  let formValues = {};
  Object.keys(fetchParams).forEach(key => {
    const value = fetchParams[key];
    const config = formConfig.find(item => item.id === key);
    switch (config?.type) {
      case "dropdown":
        const matches = (Array.isArray(value) ? value : [value]).map(value => {
          const options = (config?.props?.options || []);
          return options.find(item => item.value === value);
        });
        const isMulti = config?.props?.isMulti;
        formValues[key] = isMulti ? matches : matches[0];
        break;
      default:
        formValues[key] = fetchParams[key];
        break;
    }
  });
  return formValues;

}

export { fetchParamsToFormValues }

function Form({ className, formValues, setFormValues, shouldSubmit }) {

  const [_isModalVisible, _setIsModalVisible] = useState({});

  const isModalVisible = (id) => {
    return _isModalVisible[id];
  }

  const setIsModalVisible = (id, visible) => {
    _setIsModalVisible({ ..._isModalVisible, [id]: visible });
  }

  const onChange = (id, e) => {
    const newFormValues = changeState(formValues, id, e);
    setFormValues(newFormValues);
    return newFormValues;
  }

  const onClear = () => {
    setFormValues({});
    shouldSubmit({}, { forceSubmit: true });
  }

  const onSearch = () => {
    shouldSubmit(formValues, { forceSubmit: true });
    _setIsModalVisible({}); // Reset all modal
  }

  const context = useContext(AppContext);
  const postType = context?.post_type;
  const formConfig = context?.GET_SEARCH_FORM_CONFIG?.({ search_type: context?.search_type }) || [];

  const getControl = ({ id, type, props, children }) => {
    switch (type) {
      case "container": {
        return (
          <Container key={id} {...props}>{(children || []).map(getControl)}</Container>
        );
      }
      case "col": {
        return (
          <Col key={id} {...props}>{(children || []).map(getControl)}</Col>
        );
      }
      case "row": {
        return (
          <Row key={id} {...props}>{(children || []).map(getControl)}</Row>
        );
      }
      case "text": {
        const defaultOnChange = (value) => onChange(id, value);
        const defaultOnSubmit = () => onSearch();
        // const defaultOnChange = (value) => {
        //   const newFormValues = onChange(id, value);
        //   shouldSubmit(newFormValues, { forceSubmit: true });
        // };
        return (
          <Text
            key={id}
            onChange={defaultOnChange}
            onSubmit={defaultOnSubmit}
            {...props}
            value={formValues[id]}
          />
        );
      }
      case "dropdown": {
        const defaultOnChange = (value) => onChange(id, value);

        return (
          <Dropdown
            key={id}
            formValues={formValues}
            onChange={defaultOnChange}
            {...props}
            options={(props?.options || []).map(item => ({ ...item, className: `${id}_${item.value.toString().toLowerCase()}` }))}
            value={formValues[id]}
            />
        );
      }
      case "pill": {
        const defaultOnChange = (value) => onChange(id, value);

        return (
          <Pill
            key={id}
            formValues={formValues}
            {...props}
            onChange={value => {
              if (typeof props.onChange === "function") {
                props.onChange({ id, value, defaultOnChange, shouldSubmit })
              }
              else {
                defaultOnChange(value);
              }
            }}
            options={(props?.options || []).map(item => ({ ...item, className: `${id}_${item.value.toString().toLowerCase()}` }))}
            value={formValues[id]}
            />
        );
      }
      case "modal": {
        return (
          <div key={id}>
            <Button {...props} variant="light" onClick={() => setIsModalVisible(id, true)}><FilterIcon /></Button>
            <Modal className={`${postType} search-form`} show={isModalVisible(id)} onHide={() => setIsModalVisible(id, false)} animation={false}>
              <Modal.Body>
                {(children || []).map(getControl)}
              </Modal.Body>
            </Modal>
          </div>
        );
      }
      case "clearbutton": {
        return (
          <Button key={id} {...props} variant="light" onClick={onClear}><RotateRightIcon /> Clear</Button>
        );
      }
      case "submitbutton": {
        return (
          <Button key={id} {...props} variant="light" onClick={onSearch}><MagnifyingGlassIcon /> Search</Button>
        );
      }
      case "html": {
        return (
          <div key={id} dangerouslySetInnerHTML={{ __html: children }} {...props}></div>
        );
      }
      default: {
        const Component = type;
        return (
          <Component key={id} {...props}>{(children || []).map(getControl)}</Component>
        );
      }
    }
  }

  className = (className || "") + " search-form d-flex flex-column gap-2";
  return (
    <Container fluid className={className}>
      <div className="search-form-overlay" />
      <div className="search-form-filters">
        {formConfig.map(item => getControl(item))}
      </div>
    </Container>
  );

}

export default Form;
